import { Component, inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ResetTranslationStateAction, TranslationState } from '../../state/TranslationState';
import { TranslationService } from '../services/translation.service';
import { environment } from '../../../../environments/environment';

declare const gtag: (
  type: string,
  name: string,
  options: {
    event_category: string;
    event_label: string;
    value: string;
  }
) => void;

@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class LanguageDropdownComponent implements OnInit, OnDestroy {
  currentLanguage$: Observable<string>;
  isTranslationsLoading$: Observable<boolean>;
  supportedLanguages: string[];
  flag: string;
  private readonly store = inject(Store);
  public translationService = inject(TranslationService);
  protected sanitizer = inject(DomSanitizer);

  constructor() {}

  ngOnInit(): void {
    this.currentLanguage$ = this.store.select(TranslationState.currentLanguage);
    this.currentLanguage$.subscribe((t) => {
      switch (t) {
        case 'English (US)':
          this.flag = 'flag-us';
          break;
        case 'Español':
          this.flag = 'flag-mx';
          break;
        case 'French':
          this.flag = 'flag-fr';
          break;
        case 'Bulgarian':
          this.flag = 'flag-bg';
          break;
        case 'Italian':
          this.flag = 'flag-it';
          break;
        case 'Portuguese':
          this.flag = 'flag-pt';
          break;
      }
    });
    this.isTranslationsLoading$ = this.store.select(TranslationState.loading);
    this.isTranslationsLoading$.subscribe((v) => {
      if (!v) {
        this.supportedLanguages = this.translationService.getSupportedLanguages();
      }
    });
    this.translationService.setCurrentTranslation(this.translationService.getUserpreferedLanguage());
  }

  ngOnDestroy(): void {
    this.store.dispatch(new ResetTranslationStateAction());
  }

  languageOptionClicked(value: string) {
    if (environment.envName !== 'dev') {
      gtag('event', 'language_dropdown_clicked', {
        event_category: 'DROPDOWN_CLICK',
        event_label: 'Language Dropdown Click',
        value: `Changed Application Language to: ${value}`
      });
    }
    this.translationService.setCurrentTranslation(value);
  }
}
